import { ContentHeading } from 'components/Typography';
import AdditionalPayment from './components/AdditionalPayment';
import RefundPayment from './components/RefundPayment';
import PaymentTotals from '../PaymentTotals';
import { useChangeDates } from 'pages/ChangeDatesPage/ChangeDatesProvider';

const PaymentAdjustmentDetails = () => {
  const { amendment } = useChangeDates();

  const { type } = amendment!.amendmentTotal!;

  return (
    <>
      <ContentHeading data-testid="change-date-quote-payment-summary" mt={10} mb={2} fontSize={['xl', '2xl']}>
        Payment summary
      </ContentHeading>
      <PaymentTotals />
      {type === 'ADDITIONAL_PAYMENT' && <AdditionalPayment mt={6} mb={0} />}
      {type === 'REFUND_PAYMENT' && <RefundPayment mt={6} mb={0} />}
    </>
  );
};

export default PaymentAdjustmentDetails;
